import { createContext, useContext } from "react";

export const SiteConfigContext = createContext(null);
export const useSiteConfig = () => useContext(SiteConfigContext) || {};

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const fullUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const hexToRgba = (hex, alpha) => {
  const h = (hex || "#000000").replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const n = parseInt(full, 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
};

export function applyTheme(t) {
  if (!t) return;
  const root = document.documentElement.style;
  root.setProperty("--primary", t.primary);
  root.setProperty("--dark-bg", t.dark_bg);
  root.setProperty("--whatsapp", t.whatsapp);
  root.setProperty("--danger", t.danger);
  const opacity = Number(t.fire_opacity ?? 0.22);
  const fire = hexToRgba(t.fire, opacity);
  const fireSoft = hexToRgba(t.fire, Math.min(1, opacity + 0.08));
  root.setProperty(
    "--fire-bg",
    `linear-gradient(150deg, ${fire} 0%, transparent 55%), radial-gradient(55% 45% at 85% 15%, ${fireSoft}, transparent 70%)`
  );
}
